import {
  vArray,
  vMaxLength,
  vMinLength,
  vObject,
  vObjectId,
  type vOutput,
  vPicklist,
  vPipe,
} from '../validation/index.ts'

export const BATCH_PRINT_LIMIT = 200

export const batchDocumentTypes = ['bol', 'labels'] as const

export const documentBatchRequestSchema = vObject({
  loadIds: vPipe(
    vArray(vObjectId()),
    vMinLength(1),
    vMaxLength(BATCH_PRINT_LIMIT),
  ),
  documentType: vPicklist(batchDocumentTypes),
})

export type BatchDocumentType = (typeof batchDocumentTypes)[number]
export type DocumentBatchRequest = vOutput<typeof documentBatchRequestSchema>
